import React from 'react';
import PropTypes from 'prop-types';

import Form from '../../../../components/Form';
import Checkbox from '../../../../components/Checkbox';

const CHECKBOX_MAP = {
  'Any Semester / Not Specified': 'Any/Not Restricted/Not Specified',
  'Fall': 'Fall',
  'Winter': 'Winter',
  'Spring': 'Spring',
  'Summer': 'Summer',
};

const EnrollmentTerms = ({ initialValue, onChange }) => {
  const checkedTerms = initialValue.value ? JSON.parse(initialValue.value) : /* istanbul ignore next */[];
  const anyValue = CHECKBOX_MAP['Any Semester / Not Specified'];
  const disableAny = !!checkedTerms.find((term) => term !== anyValue && Object.keys(CHECKBOX_MAP).includes(term));
  const disableSeasons = checkedTerms.includes(anyValue);
  return (
    <div data-cy="Premium-Hem-transferEnrollmentTerms-Container">
      {Object.keys(CHECKBOX_MAP).map((key) => {
        const value = CHECKBOX_MAP[key];
        const id = `enroll_terms_${value.replace(/[\s/]/g, '')}`;
        const isAny = key === 'Any Semester / Not Specified';
        return (
          <Form.Field key={id}>
            <Checkbox
              id={id}
              label={{
                htmlFor: id,
                children: key,
              }}
              checked={checkedTerms.includes(value)}
              disabled={(isAny && disableAny) || (!isAny && disableSeasons)}
              onChange={(e) => {
                const newCheckedTerms = e.target.checked ?
                  [...checkedTerms, value] :
                  checkedTerms.filter((item) => item !== value);
                onChange(e, { value: JSON.stringify(newCheckedTerms) });
              }}
            />
          </Form.Field>
        );
      })}
    </div>
  );
};
EnrollmentTerms.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.object,
};

export default EnrollmentTerms;
